<!-- prettier-ignore -->

<div class="map-container">
    @if(!disableTouch()){
        <map-select-day [days]="days()"></map-select-day>
        <map-action-buttons></map-action-buttons>
    }
    <map-add-confirm></map-add-confirm>
    <div class="map" #mapElement [ngClass]="{'minimize-map': itemToAdd()}"></div>
    <cards-mobile-map [pointsPerDay]="pointsPerDay()" [mobileCardColor]="mobileCardColor()"></cards-mobile-map>
</div>